import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/chevron-down.svg'


const _hoisted_1 = { class: "flex justify-end" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "mr-4 capitalize" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "absolute top-8 flex flex-col bg-white rounded mt-8 w-48 shadow z-50"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "capitalize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFilter = !_ctx.openFilter))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedFilter.replaceAll("_", " ")), 1),
          _hoisted_5
        ])
      ])
    ]),
    (_ctx.openFilter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: i,
              class: "hover:bg-background-secondary rounded p-4 capitalize",
              onClick: ($event: any) => {
          _ctx.selectFilter(item);
          _ctx.closeMenu;
        }
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.name.replaceAll("_", " ")), 1)
            ], 8, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}